<template>
  <div class="variables-info">
    <p class="variables-info__title">
      Добавьте в ваш документ переменные и загрузите
      готовый файл в программу</p>
    <button
      type="button"
      class="variables-info__btn-download"
      v-on:click="onClick"
    >Скачать переменные
    </button>
  </div>
</template>

<script>
/**
 * @description Название события "Скачать переменные".
 * @type {string}
 */
const NAME_CLICK_DOWNLOAD_BUTTON_EVENT = 'click-download-button';

export default {
  /**
   * @description Компонент информации о переменных.
   */
  name: 'template-variables-info',
  methods: {
    /**
     * @description Обработать событие нажатия на кнопку "Скачать переменные".
     * @returns {void}
     */
    onClick() {
      this.$emit(NAME_CLICK_DOWNLOAD_BUTTON_EVENT);
    },
  },
};
</script>

<style scoped lang="scss">
@use "@/scss/buttons";

.variables-info {
  display: flex;
  gap: 10px;
  &__title {
    font-size: 16px;
  }
  &__btn-download {
    @include buttons.btn-transparent(100%, 48px, 16px);
    max-width: 190px;
    padding: 0;
    &:disabled {
      background-color: var(--unfocus-color);
    }
  }
}

@media screen and (max-width: 480px) {
  .variables-info {
    flex-direction: column;
  }
}
</style>
